/** @jsx jsx */
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { FilePreviewMessage } from "@/components/Files/preview/FilePreviewMessage";
import { AttachmentPreview } from "@/data/attachments/types/AttachmentPreview";

interface FilePreviewProps {
  attachment: AttachmentPreview;
  onDownloadButtonClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const FilePreview: FC<FilePreviewProps> = ({ attachment, onDownloadButtonClick }) => {
  const { t } = useTranslation("session");
  const { working, error, pdfUrl } = attachment;

  if (working) {
    return (
      <div sx={{ width: "100%", height: "100%" }}>
        <FilePreviewMessage loading />
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <FilePreviewMessage
          heading={t("COMPONENTS.PDF_PREVIEW.PREVIEW_NOT_ALLOWED")}
          instruction={t("COMPONENTS.PDF_PREVIEW.ERROR_INSTRUCTION")}
          onDownloadButtonClick={onDownloadButtonClick}
          error={true}
        />
      </div>
    );
  }

  return (
    <object sx={{ width: "100%", height: "100%" }} data={pdfUrl}>
      <FilePreviewMessage
        heading={t("COMPONENTS.PDF_PREVIEW.SUPPORT_WARNING")}
        instruction={t("COMPONENTS.PDF_PREVIEW.SUPPORT_INSTRUCTION")}
        onDownloadButtonClick={onDownloadButtonClick}
        error={true}
      />
    </object>
  );
};
